export default __webpack_public_path__ + "static/media/kaiser.a8f1cd98.png";